// pages/InfoPage.js

import Header from "../components/HomeScreen/Header";
import InfoPagesForm from "../components/InfoScreen/InfoPagesForm";
import Footer from "../components/HomeScreen/Footer";

const InfoPage = () => {
  return (
    <>
      <Header />
      <InfoPagesForm />
      <Footer />
    </>
  );
}
export default InfoPage;
